import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbPaginationNumber } from '@ng-bootstrap/ng-bootstrap';
import { GroupService } from 'src/app/shared/services/group.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { MemberService } from 'src/app/shared/services/member.service';
import { ViewMembers } from './view-members.model';
import { Location } from '@angular/common';
import { MemberSearch } from 'src/app/shared/member-search/member-search.model';

@Component({
    selector: 'app-view-members',
    templateUrl: './view-members.component.html',
    styleUrls: ['./view-members.component.scss'],
    standalone: false
})
export class ViewMembersComponent implements OnInit, AfterViewInit {
  constructor(
    private route: ActivatedRoute,
    private _router: Router,
    private groupService: GroupService,
    public globalService: GlobalService,
    private _location: Location
  ) {}

  groupId: number;
  groupName: string;
  communicationLevel: number;
  members: ViewMembers[] = [];
  leaders: ViewMembers[] = [];
  isLoading: boolean = true;
  currentUser: MemberSearch = new MemberSearch();

  async ngOnInit() {
    this.groupId = this.route.snapshot.params.groupId;
    var group = (await this.groupService.getGroup(this.groupId))['dataResult'];
    this.groupName = group.name;

    if (group.displayMembers == false) this.goHome();
    this.communicationLevel = group.communicationLevel;
    var data = await this.groupService.getMembersByGroup(this.groupId);
    data.forEach((a) => {
      a['level'] = 2;
      if (a.emailAddress == '' && a.phoneNumber == '') a['level'] = 0;
      else if (a.phoneNumber == '') a['level'] = 1;
      if (this.communicationLevel < a['level'] && a.isLeader == false)
        a['level'] = this.communicationLevel;
    });
    this.leaders = data
      .filter((a) => a.isLeader == true)
      .sort((a, b) => {
        if (a.firstName + a.lastName < b.firstName + b.lastName) return -1;
        if (a.firstName + a.lastName > b.firstName + b.lastName) return 1;
        return 0;
      });
    this.members = data
      .filter((a) => a.isLeader == false)
      .sort((a, b) => {
        if (a.firstName + a.lastName < b.firstName + b.lastName) return -1;
        if (a.firstName + a.lastName > b.firstName + b.lastName) return 1;
        return 0;
      });
    this.InitializeFunctionExpansion();
    this.isLoading = false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader = this.groupName;
    });
  }          

  leadersExist(): boolean {
    return this.members.filter((a) => a.isLeader == true).length > 0;
  }

  goHome() {
    this.globalService.screenHeader = this.globalService.title.pop();
    this.globalService.clearCurCache = false;
    this._location.back();
  }

  InitializeFunctionExpansion() {
    this.leaders.forEach((a) => {
      a['expandFunctions'] = false;
      a['toolsHelp'] = false;      
      a['expanded'] = false;
    });
    this.members.forEach((a) => {
      a['expandFunctions'] = false;
      a['toolsHelp'] = false;      
      a['expanded'] = false;
    });
  }

  ExpandFunctions(member: ViewMembers) {
    let status = member['expandFunctions'];
    this.InitializeFunctionExpansion();
    member['expandFunctions'] = !status;
    this.currentUser.memberId = 0;
    this.currentUser.firstName = member.firstName;
    this.currentUser.lastName = member.lastName;
    this.currentUser.email = member.emailAddress;
    this.currentUser.phoneNumber = member.phoneNumber;
    this.currentUser.address = '';
    this.currentUser['expandFunctions'] = true;
  }
}
